import { render, staticRenderFns } from "./ChallengerDetailChallengeMap.vue?vue&type=template&id=aba0559a&scoped=true"
import script from "./ChallengerDetailChallengeMap.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailChallengeMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0559a",
  null
  
)

export default component.exports